import { useEffect, useState } from 'react';

/**
 * Fetch data from the API. Returns null while loading or when the endpoint
 * returns an empty body. Pages must handle the null case (loading guard).
 */
export function useApi<T>(
  fetcher: () => Promise<T | null>,
  deps: any[] = []
): { data: T | null; loading: boolean; error: string | null } {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    fetcher()
      .then(result => {
        if (cancelled) return;
        setData(result);
      })
      .catch(err => {
        if (cancelled) return;
        setError(err?.message ?? 'Request failed');
      })
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error };
}
